import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLUE_500, getTestId, InfoIcon, InfoTag, tokens, Tooltip, Typography, useBreakpoint } from '@airtel/air-design-system';
import { useState } from 'react';
import { Pressable } from 'react-native';
import { View } from 'react-native';
import { ButtonWidget } from '../../../button-widget';
import { InfoListConstants } from '../../InfoListWidgetsConstants';
import { getInfoListFooterStyles } from './InfoListFooterStyles';
var returnElement = (details, setterFunction, toolTipVisibility, isLeftText, infoListFooterStyles, isLargeScreen, testID) => {
  var _a;
  return _jsxs(View, {
    children: [_jsxs(View, Object.assign({
      style: infoListFooterStyles.singleElementWrapper
    }, {
      children: [_jsx(View, Object.assign({
        style: isLeftText ? infoListFooterStyles.infoTagContainer : infoListFooterStyles.rightTextContainer
      }, {
        children: _jsx(Typography, Object.assign({}, details, {
          type: isLargeScreen ? InfoListConstants.BODY_PARA_MD_BOLD : InfoListConstants.BODY_PARA_SM_BOLD
        }))
      })), !!(details === null || details === void 0 ? void 0 : details.showToolTip) && _jsx(Tooltip, Object.assign({
        text: (_a = details === null || details === void 0 ? void 0 : details.toolTipProps) === null || _a === void 0 ? void 0 : _a.text,
        style: infoListFooterStyles.toolTipStyle,
        position: isLeftText ? 'top-start' : 'top-end',
        offset: {
          x: -10,
          y: -6
        },
        isVisible: toolTipVisibility,
        onClose: () => {
          var _a;
          if ((_a = details === null || details === void 0 ? void 0 : details.toolTipProps) === null || _a === void 0 ? void 0 : _a.autoHide) {
            setterFunction(false);
          }
        },
        autoHide: true,
        autoHideTimeout: 5000
      }, details === null || details === void 0 ? void 0 : details.toolTipProps, getTestId(testID, 'showInfoIcon'), {
        children: _jsx(Pressable, Object.assign({
          onPress: () => {
            setterFunction(prev => !prev);
          }
        }, {
          children: _jsx(InfoIcon, Object.assign({
            color: BLUE_500,
            fontSize: tokens.spacing.SPACING_16
          }, getTestId(testID, 'infoIcon')))
        }))
      }))]
    })), !!(details === null || details === void 0 ? void 0 : details.showInfoTag) && _jsx(View, Object.assign({
      style: isLeftText ? null : infoListFooterStyles.rightInfoTagContainer
    }, {
      children: _jsx(InfoTag, Object.assign({}, details === null || details === void 0 ? void 0 : details.infoTagProps, {
        size: isLargeScreen ? InfoListConstants.MD : InfoListConstants.SM
      }))
    }))]
  });
};
function InfoListFooter(props) {
  var _a, _b, _c, _d, _e, _f;
  var _props$footerElementP = props.footerElementProps,
    footerElementProps = _props$footerElementP === void 0 ? {} : _props$footerElementP,
    buttonWidgetProps = props.buttonWidgetProps,
    _props$enableCollapsi = props.enableCollapsibleView,
    enableCollapsibleView = _props$enableCollapsi === void 0 ? false : _props$enableCollapsi,
    onUserAction = props.onUserAction,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'InfoListWidgetFooter' : _props$testID;
  var checkStylingCondition = (_b = (_a = footerElementProps === null || footerElementProps === void 0 ? void 0 : footerElementProps.rightDetails) === null || _a === void 0 ? void 0 : _a.showToolTip) !== null && _b !== void 0 ? _b : false;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen,
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var infoListFooterStyles = getInfoListFooterStyles(checkStylingCondition, isLargeScreen, enableCollapsibleView);
  var _footerElementProps$s = footerElementProps.subTitle,
    subTitle = _footerElementProps$s === void 0 ? '' : _footerElementProps$s;
  var _useState = useState(false),
    leftToolTip = _useState[0],
    setLeftToolTipState = _useState[1];
  var _useState2 = useState(false),
    rightToolTip = _useState2[0],
    setRightToolTipState = _useState2[1];
  return _jsxs(View, Object.assign({
    testID: testID,
    style: infoListFooterStyles.mainContainer
  }, {
    children: [(!!((_c = footerElementProps === null || footerElementProps === void 0 ? void 0 : footerElementProps.leftDetails) === null || _c === void 0 ? void 0 : _c.text) || !!((_d = footerElementProps === null || footerElementProps === void 0 ? void 0 : footerElementProps.rightDetails) === null || _d === void 0 ? void 0 : _d.text)) && _jsxs(View, Object.assign({
      style: infoListFooterStyles.footerWrapper
    }, {
      children: [!!((_e = footerElementProps === null || footerElementProps === void 0 ? void 0 : footerElementProps.leftDetails) === null || _e === void 0 ? void 0 : _e.text) && returnElement(footerElementProps === null || footerElementProps === void 0 ? void 0 : footerElementProps.leftDetails, setLeftToolTipState, leftToolTip, true, infoListFooterStyles, isLargeScreen, testID), !!((_f = footerElementProps === null || footerElementProps === void 0 ? void 0 : footerElementProps.rightDetails) === null || _f === void 0 ? void 0 : _f.text) && returnElement(footerElementProps === null || footerElementProps === void 0 ? void 0 : footerElementProps.rightDetails, setRightToolTipState, rightToolTip, false, infoListFooterStyles, isLargeScreen, testID)]
    })), !!subTitle && _jsx(Typography, Object.assign({
      text: subTitle,
      type: "body-single-line-" + (isSmallScreen ? 'xs' : 'sm'),
      style: {
        paddingBottom: tokens.spacing.SPACING_16
      }
    }, getTestId(testID, 'subTitle'))), _jsx(ButtonWidget, Object.assign({
      testID: testID + "-ButtonWidget",
      onUserAction: onUserAction
    }, buttonWidgetProps))]
  }));
}
export default InfoListFooter;